var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-row",
        { staticClass: "padding_5px_top rankingTabRow" },
        [
          _c(
            "el-tabs",
            {
              attrs: { id: "rankingTab" },
              model: {
                value: _vm.activeTabLevl1,
                callback: function ($$v) {
                  _vm.activeTabLevl1 = $$v
                },
                expression: "activeTabLevl1",
              },
            },
            _vm._l(_vm.categories, function (item, index) {
              return _c(
                "el-tab-pane",
                { key: index, attrs: { name: "l1-" + index } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(item.name) + " "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { id: "subRankingTab" },
                      model: {
                        value: _vm.activeTabLevl2[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.activeTabLevl2, index, $$v)
                        },
                        expression: "activeTabLevl2[index]",
                      },
                    },
                    [
                      _vm._l(item.categories, function (item2, index2) {
                        return [
                          _c("el-tab-pane", {
                            attrs: { label: item2.name, name: "l2-" + index2 },
                          }),
                          _vm._v(" "),
                          _c("el-tab-pane", { attrs: { label: "|" } }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          !_vm.showWithinYearRank
            ? _c(
                "el-button",
                {
                  staticClass: "rankingTabRightButton",
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.showWithinYearRank = true
                    },
                  },
                },
                [_vm._v("展示一年以内的排名")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c(
        "el-table",
        {
          class: _vm.tableClass,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "default-sort": { prop: "PriceDate", order: "descending" },
          },
          on: { "sort-change": _vm.sortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              sortable: "custom",
              prop: "defaultSymbol",
              label: "基金代码",
              width: "110",
              "render-header": _vm.renderheaderRefreshData,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              sortable: "custom",
              prop: "legalName",
              label: "基金名称",
              "min-width": "200",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "inceptionDate",
              label: "成立日期",
              "min-width": "120",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("replaceTime")(scope.row.inceptionDate))
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("template", { slot: "header" }, [
                _c("span", [
                  _vm._v("晨星评级(" + _vm._s(_vm.ratingDate) + ") "),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "header" },
                [
                  _vm.showNoRatingIcon
                    ? _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "light",
                            content: "该类型基金不参与评级",
                            placement: "right",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-info-ms" })]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "starRating3",
                  label: "三年评级",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.checkDataHasValue(scope.row.starRating3)
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fillNull")(scope.row.starRating3)
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkDataHasValue(scope.row.starRating3)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getStarRating(scope.row.starRating3),
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticStyle: { "background-color": "red !important" },
                attrs: {
                  prop: "starRating5",
                  label: "五年评级",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.checkDataHasValue(scope.row.starRating5)
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fillNull")(scope.row.starRating5)
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkDataHasValue(scope.row.starRating5)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getStarRating(scope.row.starRating5),
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "starRating10",
                  label: "十年评级",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.checkDataHasValue(scope.row.starRating10)
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fillNull")(scope.row.starRating10)
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkDataHasValue(scope.row.starRating10)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getStarRating(scope.row.starRating10),
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "priceDate",
              label: "净值日期",
              "min-width": "120",
              sortable: "custom",
              align: "center",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("replaceTime")(scope.row.priceDate))),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nav",
              label: "单位净值|(元)",
              "min-width": "120",
              "render-header": _vm.renderheader2Row,
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("fillNullRound")(scope.row.nav, 4))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "今年以来",
                align: "center",
                "label-class-name": "col-divider-left within-year-group-head",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "returnYTD",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name":
                    "col-divider-left within-year-group-subhead",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.returnYTD, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.returnYTD)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showWithinYearRank
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "returnYTDRank",
                        label: "同类排名",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.rankTooltip(scope.row.returnYTDRank)
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showNavOutlier(
                                  scope.row.returnYTD,
                                  _vm.showNoRankingIcon,
                                  scope.row.returnYTDRankNavOutlier,
                                  scope.row.returnYTDRankSignificantRestructure
                                )
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content:
                                            "疑似净值异常波动，不参与排名",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.showTooltipContent(
                                                    scope.row.returnYTD,
                                                    _vm.showNoRankingIcon,
                                                    scope.row
                                                      .returnYTDRankNavOutlier,
                                                    scope.row
                                                      .returnYTDRankSignificantRestructure
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-info-ms",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2593916685
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("span", [_vm._v("同类排名")]),
                          _vm._v(" "),
                          _vm.showNoRankingIcon
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "该类型基金不参与排名",
                                    placement: "right",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-info-ms" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近一周",
                align: "center",
                "label-class-name": "col-divider-left within-year-group-head",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return1Week",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name":
                    "col-divider-left within-year-group-subhead",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return1Week, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return1Week)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showWithinYearRank
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "return1WeekRank",
                        label: "同类排名",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.rankTooltip(scope.row.return1WeekRank)
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showNavOutlier(
                                  scope.row.return1Week,
                                  _vm.showNoRankingIcon,
                                  scope.row.return1WeekRankNavOutlier,
                                  scope.row
                                    .return1WeekRankSignificantRestructure
                                )
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content:
                                            "疑似净值异常波动，不参与排名",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.showTooltipContent(
                                                    scope.row.return1Week,
                                                    _vm.showNoRankingIcon,
                                                    scope.row
                                                      .return1WeekRankNavOutlier,
                                                    scope.row
                                                      .return1WeekRankSignificantRestructure
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-info-ms",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2648517347
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("span", [_vm._v("同类排名")]),
                          _vm._v(" "),
                          _vm.showNoRankingIcon
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "该类型基金不参与排名",
                                    placement: "right",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-info-ms" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近一月",
                align: "center",
                "label-class-name": "col-divider-left within-year-group-head",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return1Month",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name":
                    "col-divider-left within-year-group-subhead",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return1Month, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return1Month)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showWithinYearRank
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "return1MonthRank",
                        label: "同类排名",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.rankTooltip(
                                        scope.row.return1MonthRank
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showNavOutlier(
                                  scope.row.return1Month,
                                  _vm.showNoRankingIcon,
                                  scope.row.return1MonthRankNavOutlier,
                                  scope.row
                                    .return1MonthRankSignificantRestructure
                                )
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content:
                                            "疑似净值异常波动，不参与排名",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.showTooltipContent(
                                                    scope.row.return1Month,
                                                    _vm.showNoRankingIcon,
                                                    scope.row
                                                      .return1MonthRankNavOutlier,
                                                    scope.row
                                                      .return1MonthRankSignificantRestructure
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-info-ms",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2565691023
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("span", [_vm._v("同类排名")]),
                          _vm._v(" "),
                          _vm.showNoRankingIcon
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "该类型基金不参与排名",
                                    placement: "right",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-info-ms" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近三月",
                align: "center",
                "label-class-name": "col-divider-left within-year-group-head",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return3Month",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name":
                    "col-divider-left within-year-group-subhead",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return3Month, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return3Month)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showWithinYearRank
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "return3MonthRank",
                        label: "同类排名",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.rankTooltip(
                                        scope.row.return3MonthRank
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showNavOutlier(
                                  scope.row.return3Month,
                                  _vm.showNoRankingIcon,
                                  scope.row.return3MonthRankNavOutlier,
                                  scope.row
                                    .return3MonthRankSignificantRestructure
                                )
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content:
                                            "疑似净值异常波动，不参与排名",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.showTooltipContent(
                                                    scope.row.return3Month,
                                                    _vm.showNoRankingIcon,
                                                    scope.row
                                                      .return3MonthRankNavOutlier,
                                                    scope.row
                                                      .return3MonthRankSignificantRestructure
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-info-ms",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        616025613
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("span", [_vm._v("同类排名")]),
                          _vm._v(" "),
                          _vm.showNoRankingIcon
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "该类型基金不参与排名",
                                    placement: "right",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-info-ms" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近六月",
                align: "center",
                "label-class-name": "col-divider-left within-year-group-head",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return6Month",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name":
                    "col-divider-left within-year-group-subhead",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return6Month, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return6Month)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showWithinYearRank
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "return6MonthRank",
                        label: "同类排名",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.rankTooltip(
                                        scope.row.return6MonthRank
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showNavOutlier(
                                  scope.row.return6Month,
                                  _vm.showNoRankingIcon,
                                  scope.row.return6MonthRankNavOutlier,
                                  scope.row
                                    .return6MonthRankSignificantRestructure
                                )
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content:
                                            "疑似净值异常波动，不参与排名",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.showTooltipContent(
                                                    scope.row.return6Month,
                                                    _vm.showNoRankingIcon,
                                                    scope.row
                                                      .return6MonthRankNavOutlier,
                                                    scope.row
                                                      .return6MonthRankSignificantRestructure
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-info-ms",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2706702152
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("span", [_vm._v("同类排名")]),
                          _vm._v(" "),
                          _vm.showNoRankingIcon
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "该类型基金不参与排名",
                                    placement: "right",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-info-ms" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近一年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return1Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return1Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return1Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return1YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return1YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return1Year,
                            _vm.showNoRankingIcon,
                            scope.row.return1YearRankNavOutlier,
                            scope.row.return1YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return1Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return1YearRankNavOutlier,
                                            scope.row
                                              .return1YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近两年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return2Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return2Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return2Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn2Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn2Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn2Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return2YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return2YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return2Year,
                            _vm.showNoRankingIcon,
                            scope.row.return2YearRankNavOutlier,
                            scope.row.return2YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return2Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return2YearRankNavOutlier,
                                            scope.row
                                              .return2YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近三年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return3Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return3Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return3Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn3Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn3Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn3Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return3YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return3YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return3Year,
                            _vm.showNoRankingIcon,
                            scope.row.return3YearRankNavOutlier,
                            scope.row.return3YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return3Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return3YearRankNavOutlier,
                                            scope.row
                                              .return3YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近五年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return5Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return5Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return5Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn5Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn5Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn5Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return5YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return5YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return5Year,
                            _vm.showNoRankingIcon,
                            scope.row.return5YearRankNavOutlier,
                            scope.row.return5YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return5Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return5YearRankNavOutlier,
                                            scope.row
                                              .return5YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近七年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return7Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return7Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return7Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn7Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn7Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn7Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return7YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return7YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return7Year,
                            _vm.showNoRankingIcon,
                            scope.row.return7YearRankNavOutlier,
                            scope.row.return7YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return7Year,
                                            _vm.showNoRankingIcon,
                                            scope.row.return7YearRankNavOutlier,
                                            scope.row
                                              .return7YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近十年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return10Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return10Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return10Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn10Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn10Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn10Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return10YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return10YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return10Year,
                            _vm.showNoRankingIcon,
                            scope.row.return10YearRankNavOutlier,
                            scope.row.return10YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return10Year,
                                            _vm.showNoRankingIcon,
                                            scope.row
                                              .return10YearRankNavOutlier,
                                            scope.row
                                              .return10YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "最近十五年",
                align: "center",
                "label-class-name": "col-divider-left",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "return15Year",
                  label: "年化回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                  "class-name": "col-divider-left",
                  "label-class-name": "col-divider-left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(scope.row.return15Year, 2)
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.return15Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "accReturn15Year",
                  label: "总回报率",
                  "min-width": "120",
                  sortable: "custom",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fillNullRound")(
                                scope.row.accReturn15Year,
                                2
                              )
                            )
                          ),
                        ]),
                        _vm.checkDataHasValue(scope.row.accReturn15Year)
                          ? _c("span", [_vm._v("%")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "return15YearRank",
                    label: "同类排名",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.rankTooltip(scope.row.return15YearRank)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.showNavOutlier(
                            scope.row.return15Year,
                            _vm.showNoRankingIcon,
                            scope.row.return15YearRankNavOutlier,
                            scope.row.return15YearRankSignificantRestructure
                          )
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: "疑似净值异常波动，不参与排名",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showTooltipContent(
                                            scope.row.return15Year,
                                            _vm.showNoRankingIcon,
                                            scope.row
                                              .return15YearRankNavOutlier,
                                            scope.row
                                              .return15YearRankSignificantRestructure
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "el-icon-info-ms" }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("同类排名")]),
                      _vm._v(" "),
                      _vm.showNoRankingIcon
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: "该类型基金不参与排名",
                                placement: "right",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-info-ms" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "returnInception",
              label: "成立以来|总回报率",
              "min-width": "120",
              sortable: "custom",
              "render-header": _vm.renderheader2Row,
              align: "center",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fillNullRound")(scope.row.returnInception, 2)
                        )
                      ),
                    ]),
                    _vm.checkDataHasValue(scope.row.returnInception)
                      ? _c("span", [_vm._v("%")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "categoryNameLocal",
              label: "晨星分类",
              "min-width": "220",
              "show-overflow-tooltip": "",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "categoryGroupName",
              label: "晨星分类组别",
              "min-width": "140",
              "show-overflow-tooltip": "",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "broadCategoryName_CN",
              label: "晨星资产大类",
              "min-width": "140",
              "show-overflow-tooltip": "",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ifOldestShare",
              label: "是否最早份额",
              "min-width": "120",
              align: "center",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm.formatBooleanFlag(scope.row.ifOldestShare))
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ifPeerGroupMembershipChange",
              label: "是否转型基金",
              "min-width": "120",
              align: "center",
              "class-name": "col-divider-left",
              "label-class-name": "col-divider-left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.formatBooleanFlag(
                          scope.row.ifPeerGroupMembershipChange
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "left_text_align padding_25px_top" },
        [
          (_vm.pagination.count > 10 ? true : false)
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.params.page,
                  "page-sizes": [10, 20, 50, 100, 200],
                  "page-size": _vm.pagination.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: (_vm.pagination && _vm.pagination.count) || 0,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.params, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.params, "page", $event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }